import { blue, green, orange, red } from "@material-ui/core/colors";

// Enum real que entrega el backend (CRM-3109): PENDIENTE | ENVIADA | TIMBRADA | ERROR.
export const globalInvoiceStatus = {
  PENDIENTE: {
    value: "PENDIENTE",
    translate: "Pendiente de envío",
    color: orange[900],
    bgColor: orange[100],
  },
  ENVIADA: {
    value: "ENVIADA",
    translate: "Enviada",
    color: blue[900],
    bgColor: blue[100],
  },
  TIMBRADA: {
    value: "TIMBRADA",
    translate: "Timbrada",
    color: green[900],
    bgColor: green[100],
  },
  ERROR: {
    value: "ERROR",
    translate: "Error",
    color: red[900],
    bgColor: red[100],
  },
};
